/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2019-07-02 17:08:11
 * @LastAuthor   : xiaoyao
 * @lastTime     : 2019-12-26 16:23:46
 */
import Mock from 'mockjs2'
import { builder } from '@/mock/util'

const customerDetail = {
    insured: {
        name: '张三',
        id_code: '110112199505056666',
        mobile1: '13888888888',
        mobile2: '13888888888'
    },
    car: {
        LICENSE_NO: '川A12345',
        MODEL: 'S33F21',
        VIN_NO: 's4444',
        ENGINE_NO: '3124',
        SEATS: '5',
        ENGINE: '2.0',
        BUYING_PRICE: '230000',
        ENROLL_DATE: '2019-05-22',
        USE_CHARACTER: '家庭自用汽车'
    },
    remark:{
        remark: '这是一条备注'
    }
}

const vehicleInfo = [
        {
            "purchasePrice": 128300,
            "class": "轿车类",
            "seats": 5,
            "tonnage": 0,
            "year": "201212",
            "id": "DZAAND0111",
            "name": "大众FV7162FAAGG轿车",
            "displacement": 1.598,
            "alias": "宝来1.6L AT豪华型",
            "brand": "大众",
            "brandType": "DZA",
            "power": "77",
            "weight": "1.31",
            "production": "进口"
        },
        {
            "purchasePrice": 135300,
            "class": "轿车类",
            "seats": 5,
            "tonnage": 0,
            "year": "201512",
            "id": "DZAAND0122",
            "name": "大众FV7162FXXXX轿车",
            "displacement": 1.598,
            "alias": "宝来1.6L AT土豪金",
            "brand": "大众",
            "brandType": "DZA",
            "power": "77",
            "weight": "1.31",
            "production": "进口"
        }
    ]

const getCustomerDetail = (id) => {
    return builder(customerDetail)
}

const getVehicleInfo = (id) => {
    return builder(vehicleInfo)
}
Mock.mock(/\/customer\/detail/, 'get', getCustomerDetail)
Mock.mock(/\/vehicle-info/, 'get', getVehicleInfo)


// WEBPACK FOOTER //
// ./src/mock/services/list/customer-file/detail.js